import { Environment } from './environment';
import { Project } from './project';

export type EnvironmentResource = {
    projectId: Project.Id;
    environmentId: Environment.Id;
}

export type Resource = EnvironmentResource;

function isEnvironmentResource(res: Resource): res is EnvironmentResource {
    return 'environmentId' in res;
}

export type Permission = {
    resource: Resource;
    operations: string[];
}

export function equalOperations(lhs: string[], rhs: string[]): boolean {
    return lhs.length === rhs.length && lhs.every((x, i) => x === rhs[i]);
}

export function equalResource(lhs: Resource, rhs: Resource): boolean {
    if (isEnvironmentResource(lhs) && isEnvironmentResource(rhs)) {
        return lhs.projectId === rhs.projectId && lhs.environmentId === rhs.environmentId;
    }
    return false;
}

export function equalPermission(lhs: Permission, rhs: Permission): boolean {
    return equalResource(lhs.resource, rhs.resource) && equalOperations(lhs.operations, rhs.operations);
}

export function makePermission(
    resource: { projectId: Project.Id, environmentId: Environment.Id },
    operations: string[],
): Permission {
    return {
        resource,
        operations,
    };
}

export type Scope = Array<Permission>;
